import { useLocation } from 'react-router-dom';
import { isUnifiedEntityFramePath } from './company-profile-route';
import { useUnifiedShell } from './use-unified-shell';

/**
 * Whether the current route is an entity page that renders inside the unified shell's frame: an
 * opted-in user (`useUnifiedShell`) on a company, fund, portfolio or product profile, or on a
 * company, fund or portfolio impact drilldown (`isUnifiedEntityFramePath`).
 *
 * The header switch (`root/main/header-maybe.tsx`) paints no bar on these routes, so the page must
 * bring `UnifiedShellFrame` in every state it can be in, its loading and error states included. That
 * is why the drilldown frames and `BouToolPageLoading` read this too, rather than each re-deriving
 * the condition.
 *
 * `loading` is a customer's opt-in still resolving on one of these routes. Off them it is `false`,
 * because the answer does not depend on the opt-in there.
 */
export function useUnifiedEntityFrameActive(): { active: boolean; loading: boolean } {
  const shell = useUnifiedShell();
  const { pathname } = useLocation();
  if (!isUnifiedEntityFramePath(pathname)) return { active: false, loading: false };
  return { active: shell.enabled, loading: shell.loading };
}
